var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"description-price"},_vm._l((_vm.filteredDes),function(des,index){return _c('span',{key:index},[_vm._v(" "+_vm._s(((des.key) + " " + (des.value)))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }